/**
 * Renders a "new version available" prompt when the API's
 * `X-Build-Hash` header changes mid-session. Mounted once at the root.
 *
 * The page can keep working — the SPA bundle and the API are
 * versioned independently and additions to API responses are
 * backwards-compatible — but if the user leaves the page open across
 * a deploy, eventually the bundle's expectations and the API's shape
 * will drift far enough that requests fail or render bugs surface.
 * Hard-refreshing fixes it. This banner makes that explicit instead
 * of letting the user discover it through broken pages.
 */
import { useBuildDrift } from '../lib/build-version.ts';

export function BuildDriftBanner() {
  const drifted = useBuildDrift();
  if (!drifted) return null;
  return (
    <div
      role='status'
      aria-live='polite'
      style={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999,
        padding: '10px 16px',
        background: 'var(--surface-emphasis, #1f2937)',
        color: 'var(--on-emphasis, #f9fafb)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        fontSize: 13,
        boxShadow: '0 -1px 6px rgba(0,0,0,0.18)',
      }}
    >
      <span>A new version is available.</span>
      <button
        type='button'
        onClick={() => window.location.reload()}
        style={{
          background: 'var(--primary, #2563eb)',
          color: '#fff',
          border: 0,
          borderRadius: 6,
          padding: '4px 12px',
          fontSize: 12,
          fontWeight: 600,
          cursor: 'pointer',
        }}
      >
        Refresh
      </button>
    </div>
  );
}
